<div class="mt">
    <form novalidate>
        <div class="row">
            <div class="col-md col-12">
                <label class="header-label">Search:</label>
                <input class="search-text-input form-control"
                       type="text"
                       placeholder="Enter Keyword"
                       [ngModel]="searchValue"
                       [ngModelOptions]="{standalone: true}"
                       (ngModelChange)="setSearchValue($event)"/>
            </div>
            <div class="col-md col-12" *ngIf="isRegionAdmin; else agencyModalBlock">
                <label class="header-label">Agency:</label>
                <ng-select
                    [items]="regionAdminManagedAgencies"
                    bindLabel="agencyName"
                    bindValue="id"
                    [(ngModel)]="selectedAgencyId"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="-- Select Agency --"
                    [clearable]="true"
                    class="custom-single-select">
                </ng-select>
            </div>
            <ng-template #agencyModalBlock>
            <div class="col-md col-12">
                <label class="header-label">Agency:</label>
                <input class="agency-modal-input form-control"
                       type="text"
                       placeholder="Select agency to filter"
                       (click)="showAgencyModal()"
                       (keydown)="showAgencyModal()"
                       value="{{selectedAgencyName}}"
                       [disabled]="isDisabledAgency()"/>
            </div>
            </ng-template>
            <div class="col-md col-12 dropdown-menu-top" *ngIf="hasRegionAdminFilter && isAdmin">
                <label class="header-label">Region Admin Agency:</label>
                <select name="" id="" class="form-select form-control" [formControl]="selectedManagementAgencyId">
                    <option value="">-- Select Region Admin Agency--</option>
                    <option *ngFor="let agency of regionAdminAgencies"
                            [value]="agency.id">{{agency.agencyName}}</option>
                </select>
            </div>
            <div class="col-md col-12 dropdown-menu-top custom-multiple-select-wrapper" *ngIf="hasFundTypeFilter">
                <label class="header-label">Fund Type:</label>
                <ng-select
                    [items]="fundTypes"
                    bindLabel="displayName"
                    bindValue="id"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [formControl]="selectedFundTypeIds"
                    placeholder="-- Filter By Fund Type --"
                    class="custom-multiple-select">
                </ng-select>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <button class="btn btn-primary pull-left" role="button"
                        (click)="searchDrafts()">Search
                </button>
                <button class="btn btn-secondary ms-5" role="button"
                        (click)="clearFilters()">Clear Filters
                </button>
            </div>
        </div>
    </form>
    <table-dynamic id="drafts-datatable" class="table table-striped table-hover"
                   [headers]="tableHeaders" [currentPage]="currentPage" [totalCount]="totalCount"
                   (headerClick)="sortDrafts($event)" (pageChanged)="setPage($event)"
                   (limitChange)="setLimit($event)">
        <tr *ngFor="let draft of draftsList?.items" class="clickable-row" (click)="navigateToDraft(draft)">
            <td>{{draft?.fundTypeName}}</td>
            <td><a [routerLink]="['../client', draft?.clientId]" (click)="$event.stopPropagation()"><strong>{{draft?.clientLastName}}</strong></a></td>
            <td>{{draft?.clientFirstName}}</td>
            <td>***-**-{{draft?.clientLast4Ssn}}</td>
            <td>{{draft?.createdDate | moment: 'L'}}</td>
            <td>{{draft?.agencyName}}</td>
            <td>{{draft?.createdByName}}</td>
            <td>{{draft?.createdByEmail}}</td>
        </tr>
    </table-dynamic>
    <agency-box id="draftsAgencyListModal" #agencyListModal (onAgencySelected)="onAgencySelected($event)"></agency-box>
</div>
